
import EmptyHome from '@/ui/components/Home/Empty/EmptyHome'
import Teaser from '@/ui/components/Teaser/Teaser'
import AssistantCard from '@/ui/components/AssistantCard/AssistantCard'
import { getAssistantIllustration } from '@/hooks/useAssistantIllustration'
// utils
import { titleSizes } from '@/constants'
import { HomeProperties } from '@/ui/components/Home/types'
import { DisplayMode } from '@/ui/types/DisplayMode'
import utils from '@/utils/utils'

import './DefaultHome.scss'

const DefaultHome = ({ space, information, translate, tileHandler }: HomeProperties) => {

    const hasAssistants = space?.assistants && space?.assistants.length > 0
    const rawName = information.account?.name || information.account?.username
    const givenName = utils.extractFirstName(rawName)

    let greetingsTitle = translate('home:greetingsTitle')

    if (givenName)
        greetingsTitle = `${greetingsTitle}, ${givenName}?`

    return (
        <div className='default-home'>
            <div className='home-assistants'>
                <div className='home-image'>
                    <img src={getAssistantIllustration()} alt='Assistant Logo' />
                </div>
                <div className='home-assistants-wrapper'>
                    <p className={`title -size-${titleSizes[2]}`}>{greetingsTitle}</p>

                    {
                        !hasAssistants &&
                        <EmptyHome
                            information={information}
                            translate={translate}
                        />
                    }

                    {
                        hasAssistants &&
                        <Teaser columns={2}>
                            {
                                space.assistants.map((assistant, index) => {
                                    const appearance = assistant.config.appearance
                                    const shortDescription = utils.checkDefaultDescription(translate(`${assistant.config.id}:description`), appearance)
                                    const name = utils.checkDefaultName(translate(`${assistant.config.id}:name`), assistant) ?? ""
                                    const badges = utils.getAssistantBadges(assistant)

                                    return (
                                        <AssistantCard
                                            key={index}
                                            icon={appearance.icon}
                                            iconSrc={appearance.iconSrc}
                                            name={name}
                                            description={shortDescription ?? ''}
                                            tileHandler={() => tileHandler(assistant)}
                                            badges={badges}
                                            mode={DisplayMode.DEFAULT}
                                        />
                                    )
                                })
                            }
                        </Teaser>
                    }

                </div>
            </div>
        </div>
    )
}

export default DefaultHome